module.exports = __webpack_public_path__ + "img/img1.ba733e9b.jpg";